export const PROJECT_STATUS_LABELS = { active: "Activo", paused: "Pausado", done: "Terminado", archived: "Archivado" };
export const PROJECT_PRIORITY_LABELS = { low: "Baja", normal: "Normal", high: "Alta" };
export const PROJECT_DOMAIN_LABELS = { personal: "Personal", home: "Hogar", freelance: "Freelance", career: "Carrera", business: "Negocios", finance: "Finanzas", other: "Otro" };
export const COMMITMENT_KIND_LABELS = { task: "Tarea", follow_up: "Seguimiento", appointment: "Reunión", promise: "Promesa", reminder: "Recordatorio", project_next_step: "Próximo paso" };
export const RECURRING_STATUS_LABELS = { active: "Activa", paused: "Pausada", ended: "Finalizada" };
export const CONTRACT_STATUS_LABELS = { not_defined: "Sin definir", not_required: "No aplica", pending: "Pendiente", sent: "Enviado", signed: "Firmado" };
export const WEBPROFIT_STATUS_LABELS = { active: "Activo", paused: "Pausado", cancelled: "Cancelado", archived: "Archivado", draft: "Borrador" };

export function idOf(value) {
  return String(value?.id || value?._id || value || "");
}

export function minutesLabel(value, empty = "Sin registrar") {
  if (value === null || value === undefined || value === "") return empty;
  const minutes = Math.max(0, Number(value || 0));
  const hours = Math.floor(minutes / 60);
  const remainder = Math.round(minutes % 60);
  if (!hours) return `${remainder} min`;
  return remainder ? `${hours} h ${remainder} min` : `${hours} h`;
}

export function dateOnlyLabel(value, empty = "Sin fecha") {
  if (!value) return empty;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return empty;
  return new Intl.DateTimeFormat("es-AR", { day: "2-digit", month: "short", year: "numeric" }).format(date);
}

export function dateTimeLabel(value, empty = "Sin fecha") {
  if (!value) return empty;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return empty;
  return new Intl.DateTimeFormat("es-AR", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
}

export function safeExternalUrl(value) {
  try {
    const parsed = new URL(String(value || ""));
    return ["http:", "https:"].includes(parsed.protocol) ? parsed.toString() : "";
  } catch {
    return "";
  }
}
